import { MessageType } from './message-type';

export class Message {
    public text: string = null;
    public type: MessageType = MessageType.danger;
    constructor(text: string, type: MessageType) {
        this.text = text;
        this.type = type;
    }
}
